//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    padding: ${({ padding = 0 }) => padding};
    @media (min-width: 750px) {
        min-width: ${({ minWidth = "400px" }) => minWidth};
        width: ${({ width = "470px" }) => width};
    }
`;
export const Header = styled.header`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    & > img {
        position: absolute;
        top: -12%;
    }
    & > h2 {
        font-size: 18px;
        margin: 0;
        margin-top: 55px;
    }
`;
export const Message = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    & .text {
        color: var(--green-1);
        font-weight: 500;
    }
    & .iconify {
        color: var(--green-1);
        font-size: 25px;
    }
    &.not-found {
        & .text {
            color: var(--red-2);
        }
        & .iconify {
            color: var(--red-2);
        }
    }
`;
export const Content = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    gap: 20px;
    width: 100%;
`;
export const SearchField = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80%;
    position: relative;
    & > div {
        width: 100%;
        box-sizing: border-box; 
    }
`;
export const HelperSection = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center; 
    gap: 15px;
    margin: 0 20px;
    margin-bottom: 15px;
    & > div[data-role="main"] {
        display: flex;
        align-items: center; 
        gap: 6px;
    }
    & h4, & h5, & h6 { 
        margin: 0;
        font-weight: 400; 
    }
    & h5 { font-size: 14px; }
    & h4 { 
        text-align: center;
        font-size: 16px; 
    }
    & h6 { font-size: 12px; }
`;